import SearchIcon from '@mui/icons-material/Search';
import {
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Theme,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import { useState } from 'react';
import { SextforceAutoCampaignTipReplySortBy } from '../../../../hooks/useSextforceAutoCampaignTipReply';

type Props = {
    isLoading: boolean;
    active: boolean;
    setActive: (active: boolean) => void;
    setQuery: (query: string) => void;
    startDate: Date;
    setStartDate: (startDate: Date) => void;
    endDate: Date;
    setEndDate: (endDate: Date) => void;
    sortBy: SextforceAutoCampaignTipReplySortBy;
    setSortBy: (sortBy: SextforceAutoCampaignTipReplySortBy) => void;
    theme: Theme;
};

const SextforceAutoCampaignTipReplySearchBar = (props: Props) => {
    const { active, setActive, setQuery, sortBy, setSortBy, theme } = props;

    const [queryText, setQueryText] = useState<string>('');

    const handleQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Add a small delay to avoid too many requests
        setTimeout(() => {
            setQuery(event.target.value);
        }, 500);

        setQueryText(event.target.value);
    };

    return (
        <Grid container spacing={1} alignItems="center" sx={{ marginBottom: theme.spacing(2) }}>
            <Grid item xs="auto">
                <ToggleButtonGroup
                    color="primary"
                    value={active}
                    exclusive
                    size="small"
                    onChange={(event, value) => {
                        if (value !== null) {
                            setActive(value);
                        }
                    }}
                    sx={{
                        backgroundColor: theme.palette.background.paper,
                        // Match the height of the small search field
                        '& .MuiToggleButton-root': {
                            height: 40,
                        },
                    }}
                >
                    <ToggleButton value={true}>Active</ToggleButton>
                    <ToggleButton value={false}>Inactive</ToggleButton>
                </ToggleButtonGroup>
            </Grid>

            <Grid item xs>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search campaigns..."
                    value={queryText}
                    onChange={handleQueryChange}
                    onKeyDown={e => {
                        // Clear on Escape
                        if (e.key === 'Escape') {
                            setQuery('');
                            setQueryText('');
                        }
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        backgroundColor: theme.palette.background.paper,
                    }}
                />
            </Grid>

            <Grid item xs={12} sm="auto">
                <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
                    <InputLabel id="sort-by-label">Sort by</InputLabel>
                    <Select
                        labelId="sort-by-label"
                        label="Sort by"
                        fullWidth
                        size="small"
                        value={sortBy}
                        onChange={e => {
                            setSortBy(e.target.value as SextforceAutoCampaignTipReplySortBy);
                        }}
                        sx={{
                            backgroundColor: theme.palette.background.paper,
                        }}
                    >
                        <MenuItem value={'_id'}>Date Added</MenuItem>
                        <MenuItem value={'name'}>Name</MenuItem>
                        <MenuItem value={'description'}>Description</MenuItem>
                        <MenuItem value={'postDate'}>Post Date</MenuItem>
                        <MenuItem value={'replyCount'}>Replies</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default SextforceAutoCampaignTipReplySearchBar;
